/*
 * @Author: guoyu
 * @Date: 2020-12-28 15:48:59
 * @LastEditors: your name
 * @LastEditTime: 2021-05-14 15:28:12
 * @Description: 將模板組件轉換為函數式調用組件
 */
import Vue from 'vue';
import router from '@/router';
import store from '@/store';

export default function getAmountComponent(templateCompnent, options = {}) {
  const {
    props = {},
    on = {},
    nativeOn = {}
  } = options;
  let parentEl = options.parentEl || document.body
  const amountComponet = {
    data() {
      return {
        props,
        on,
        nativeOn
      };
    },
    methods: {
      deleteSelf() {
        this.$nextTick(() => {
          this.$destroy();
        });
      },
      getOnConfig() {
        return {
          ...this.on,
          destroy: this.deleteSelf
        };
      }
    },
    render() {
      return (
        <templateCompnent
          props={this.props}
          on={this.getOnConfig()}
          nativeOn={this.nativeOn}
        ></templateCompnent>
      );
    },
    destroyed() {
      parentEl.removeChild(this.$el);
    }
  };
  const AmountExtend = Vue.extend(amountComponet);
  return function insertComponent(options = {}) {
    const { props = {}, on = {}, nativeOn = {} } = options;
    const handleInstance = new AmountExtend({
      el: document.createElement('div'),
      router,
      store,
      data() {
        return {
          props,
          on,
          nativeOn
        };
      }
    });
    parentEl = options.parentEl || parentEl;
    parentEl.appendChild(handleInstance.$el);
    return handleInstance;
  };
}
